<app-table [data]="toolReturnHistory"
           [config]="tableConfig"
           [isLoading]="isLoading"
           [rowExpand]="false"
           [isMaterial]="false"
           [hasTitle]="hasTitle"
           [title]="'admin.request-history.return-history-table.title' | translate"
           [headerBackgroundColor]="headerBackgroundColor"
           (sortChange)="onSortChange($event)"
           (rowClick)="onTableRowClick($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)">
    <app-table-column [header]="'admin.request-history.return-history-table.columns.returnName' | translate"
                      [filterPlaceholder]="'admin.request-history.return-history-table.filter.placeholder.returnName' | translate"
                      [filter]="true"
                      field="name">
        <ng-template #body
                     let-toolReturnHistory="rowData">
            <span>{{ toolReturnHistory.name }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'admin.request-history.return-history-table.columns.partNumber' | translate"
                      [filterPlaceholder]="'admin.request-history.return-history-table.filter.placeholder.partNumber' | translate"
                      [filter]="true"
                      field="partNumber">
        <ng-template #body
                     let-toolReturnHistory="rowData">
            <span>{{ toolReturnHistory.partNumber?.name }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'admin.request-history.return-history-table.columns.returnStatus' | translate"
                      field="requestStatus">
        <ng-template #body
                     let-request="rowData">
            <span>{{ request.status | translate }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'admin.request-history.return-history-table.columns.createdBy' | translate"
                      [filterPlaceholder]="'admin.request-history.return-history-table.filter.placeholder.createdBy' | translate"
                      [filter]="true"
                      field="createdBy">
        <ng-template #body
                     let-toolReturnHistory="rowData">
            <span>{{ toolReturnHistory.createdBy?.firstName }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column #date
                      [sortable]="true"
                      [header]="'admin.request-history.return-history-table.columns.createdDate' | translate"
                      field="createdDate">
    </app-table-column>
    <app-table-column [header]="'admin.request-history.return-history-table.columns.modifiedBy' | translate"
                      field="modifiedBy">
        <ng-template #body
                     let-toolReturnHistory="rowData">
            <span>{{ toolReturnHistory.modifiedBy?.firstName }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column #date
                      [sortable]="true"
                      [header]="'admin.request-history.return-history-table.columns.modifiedDate' | translate"
                      field="modifiedDate">
    </app-table-column>
    <app-table-column [header]="'admin.request-history.request-history-table.columns.requestType' | translate"
                      field="type">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="filterTypeList"
                          valueField="value"
                          displayField="name"
                          [emptyText]="'admin.request-history.request-history-table.filter.placeholder.requestType' | translate"
                          (selectItem)="table.onFilterChange(column)"></app-dropdown>
        </ng-template>
        <ng-template #body
                     let-request="rowData">
            <span>{{ request.type | translate }}</span>
        </ng-template>
    </app-table-column>
</app-table>
